// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixedOverlay__keDW8Dp6M_PKogstIGlg {
  position: fixed;
  pointer-events: none;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--cp-zIndexBadge);
  overflow: hidden;
}

.contentSurface__yPxOTtYEtk30suNyVT_f {
  pointer-events: auto;
  /* children behave as if they're direct children of the next element up */
  display: contents;
}

/* badge root */
.badge__g8vMw44BD035wMgB4fi5 {
  position: absolute;
  bottom: 4px;
  right: 4px;
  box-sizing: border-box;
  height: 32px;
  padding: 4px;
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  font-size: var(--cp-fontSizeSm);
  line-height: 1;
  background: var(--cp-neutralTertiaryAlt);
  box-shadow: 0 0 12px -6px rgb(var(--cp-blackRgb) / 0.75);
  border: 1px solid var(--cp-border);
  border-radius: 4px;
  transition:
    background-color 0.2s ease-in-out,
    width 0.2s ease-in-out;
}
.badge__g8vMw44BD035wMgB4fi5.success__zHoa7JHokcPrDo9fUK7t {
  background: var(--cp-successMed);
}
.badge__g8vMw44BD035wMgB4fi5.warning__Jl_ahBnxzwLzgquDusZ6 {
  background: var(--cp-warningMed);
}
.badge__g8vMw44BD035wMgB4fi5.error__xrMdFjTpTTv1b_9S_5z6 {
  background: var(--cp-errorMed);
}

.gripArea__wiFl5y3aYfqknNzV2wkC {
  box-sizing: border-box;
  display: flex;
  gap: 2px;
  align-items: stretch;
  height: 100%;
  padding-inline-start: 2px;
  cursor: move;
}

.grip__L7TZ7XUzFVL4XtqrGq4V {
  width: 2px;
  background: rgb(var(--cp-blackRgb) / 0.2);
}

/* short status + expand button */
.button__sNDf4Vc57GDSrCocrEM4 {
  border: none;
  border-radius: 3px;
  padding: 0;
  margin: 0;
  font: inherit;
}
.button__sNDf4Vc57GDSrCocrEM4:hover {
  filter: invert(0.1);
}

.buttonText__DI7dbo1rgbopYUd5O8HW {
  font-weight: 600;
  background: rgb(var(--cp-whiteRgb) / 0.4);
  box-shadow: 2px 2px 3px -1px rgb(var(--cp-blackRgb) / 0.15) inset;
  padding: 5px 8px;
  border-radius: 3px;
}

button.chevron__pkF2KaBbsrwg9OaLE3UJ {
  font-size: inherit;
  width: 20px;
  height: 24px;
  margin-inline-start: -4px;
}
button.chevron__pkF2KaBbsrwg9OaLE3UJ.collapsed__XuyZoKa6W1UP6CkhLaKw {
  margin: 0;
  transform: scaleX(-1);
}
`, "",{"version":3,"sources":["webpack://./src/components/StatusBadge/StatusBadge.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,yEAAyE;EACzE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;EACxC,wDAAwD;EACxD,kCAAkC;EAClC,kBAAkB;EAClB;;0BAEwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iEAAiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,qBAAqB;AACvB","sourcesContent":[".fixedOverlay {\n  position: fixed;\n  pointer-events: none;\n  background: transparent;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: var(--cp-zIndexBadge);\n  overflow: hidden;\n}\n\n.contentSurface {\n  pointer-events: auto;\n  /* children behave as if they're direct children of the next element up */\n  display: contents;\n}\n\n/* badge root */\n.badge {\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n  box-sizing: border-box;\n  height: 32px;\n  padding: 4px;\n  display: inline-flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--cp-fontSizeSm);\n  line-height: 1;\n  background: var(--cp-neutralTertiaryAlt);\n  box-shadow: 0 0 12px -6px rgb(var(--cp-blackRgb) / 0.75);\n  border: 1px solid var(--cp-border);\n  border-radius: 4px;\n  transition:\n    background-color 0.2s ease-in-out,\n    width 0.2s ease-in-out;\n}\n.badge.success {\n  background: var(--cp-successMed);\n}\n.badge.warning {\n  background: var(--cp-warningMed);\n}\n.badge.error {\n  background: var(--cp-errorMed);\n}\n\n.gripArea {\n  box-sizing: border-box;\n  display: flex;\n  gap: 2px;\n  align-items: stretch;\n  height: 100%;\n  padding-inline-start: 2px;\n  cursor: move;\n}\n\n.grip {\n  width: 2px;\n  background: rgb(var(--cp-blackRgb) / 0.2);\n}\n\n/* short status + expand button */\n.button {\n  border: none;\n  border-radius: 3px;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n}\n.button:hover {\n  filter: invert(0.1);\n}\n\n.buttonText {\n  font-weight: 600;\n  background: rgb(var(--cp-whiteRgb) / 0.4);\n  box-shadow: 2px 2px 3px -1px rgb(var(--cp-blackRgb) / 0.15) inset;\n  padding: 5px 8px;\n  border-radius: 3px;\n}\n\nbutton.chevron {\n  font-size: inherit;\n  width: 20px;\n  height: 24px;\n  margin-inline-start: -4px;\n}\nbutton.chevron.collapsed {\n  margin: 0;\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fixedOverlay": `fixedOverlay__keDW8Dp6M_PKogstIGlg`,
	"contentSurface": `contentSurface__yPxOTtYEtk30suNyVT_f`,
	"badge": `badge__g8vMw44BD035wMgB4fi5`,
	"success": `success__zHoa7JHokcPrDo9fUK7t`,
	"warning": `warning__Jl_ahBnxzwLzgquDusZ6`,
	"error": `error__xrMdFjTpTTv1b_9S_5z6`,
	"gripArea": `gripArea__wiFl5y3aYfqknNzV2wkC`,
	"grip": `grip__L7TZ7XUzFVL4XtqrGq4V`,
	"button": `button__sNDf4Vc57GDSrCocrEM4`,
	"buttonText": `buttonText__DI7dbo1rgbopYUd5O8HW`,
	"chevron": `chevron__pkF2KaBbsrwg9OaLE3UJ`,
	"collapsed": `collapsed__XuyZoKa6W1UP6CkhLaKw`
};
export default ___CSS_LOADER_EXPORT___;
